import React, { FunctionComponent } from 'react';
import TopicContainer from '../topicContainer';
import TopicItem from '../topicItem';
import Section from './section';

export interface ITopicProps {
  settings: any;
  components: { [key: string]: FunctionComponent<any> };
}

const Topics: React.FunctionComponent<ITopicProps> = ({
  settings,
  components,
}) => (
  <TopicContainer className={settings.className}>
    {settings.paragraphs?.map((section: any, index: number) => (
      <TopicItem
        className="topic-item"
        key={`${section.id}${index}`}
        id={section.id}
        settings={section}
      >
        <Section settings={section} components={components} />
      </TopicItem>
    ))}
  </TopicContainer>
);
export default Topics;
